import { c as _c } from "react/compiler-runtime";
import { MainPageLayout } from "@components/page-layout/main-page-layout";
import { Grid } from "@mui-wrapper";
import { ForbiddenPage } from "@pages/forbidden-page";

/**
 * Page shown when a user tries to access a resource they don't have access to.
 * Displays the ForbiddenPage within a minimal layout (no sidebar, breadcrumbs, or searchbar).
 */
export function ForbiddenAccessPage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      minHeight: "100vh",
      backgroundColor: "surfaces.secondary",
      position: "relative",
      overflow: "hidden"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Grid container={true} sx={t0}><MainPageLayout shouldShowSidebar={false} shouldShowLogo={true} shouldHideOpenButton={true} shouldShowBreadcrumbs={false}><Grid container={true} sx={{
          marginTop: "55px"
        }}><ForbiddenPage /></Grid></MainPageLayout></Grid>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}